




















































































































































































































































































// import Element from 'element-ui'
import { Component, Vue } from 'vue-property-decorator'
import {
  CruisePlanData, emptyCruisePlan, getInfo, getTaskList
} from '@/api/cruisePlan/index'
import ViewDialog from '@/components/dialog/viewDialog.vue'

@Component({
  components: {
    ViewDialog
  }
})
export default class CruisePlanView extends Vue {
  public showDialog: boolean = false
  public loading: boolean = false
  public collapseNames: string[] = ['info', 'schedule', 'teamMembers', 'unit']
  public tabName: string = 'info'
  public form: CruisePlanData = emptyCruisePlan
  public taskList: any[] = []
  public $refs!: {}

  public allText: string = '所有'
  public created() { }
  public mounted() {
    window.eventBus.$on('viewCruisePlan', (id: number) => {
      this.tabName = 'info'
      this.showDialog = true
      this.fetchData(id)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('viewCruisePlan')
  }
  public close() {
    this.showDialog = false
  }

  get endHour(): string {
    var f = this.form
    if (f && f.ScheduleType == 1) {
      if (f.ScheduleList.length > 0) {
        return f.ScheduleList[f.ScheduleList.length - 1].ScheduleEnd
      }
    }
    return ''
  }
  public fetchData(id: number) {
    this.loading = true
    getInfo(id)
      .then((response: { data: any }) => {
        this.form = response.data
        this.loading = false
      })
      .catch((error: any) => {
        console.log(error)
      })

    getTaskList(id).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        this.taskList = data
        this.loading = false
      }
    })
  }

}
